export default {
  status: [
    {
      title: 'Convite App',
      color: 'primary',
      go_to: 'clientes',
      checked: {
        attr: 'acesso_realizado',
        name: '', // Nome do profissional
      },
      subtitle_light: {
        attr: '',
        name: 'Data de registro',
      },
      subtitle_dark: {
        attr: 'data_registro',
        name: '',
      },
      actions: [
        {
          text: 'Envio convite',
          checked: {
            attr: 'envio_convite',
            name: '',
          },
        },
        {
          text: 'Acesso realizado',
          checked: {
            attr: 'acesso_realizado',
            name: '',
          },
        },
      ],
    },
    {
      title: 'Serviço Contratado',
      color: 'primary',
      // can_show: 'services',
      go_to: 'servicos',
      checked: {
        attr: 'servico',
        name: '', // Nome do profissional
      },
      subtitle_light: {
        attr: 'servico_nome',
        name: '',
      },
      subtitle_dark: {
        attr: 'servico_dias_atras',
        name: '',
      },
    },
    {
      title: 'Ativos atuais',
      color: 'primary',
      go_to: 'carteira.minha',
      checked: {
        attr: 'ativo_proximo_vencimento',
        name: '', // Nome do profissional
      },
      subtitle_light: {
        attr: '',
        name: 'Próx. vencimento',
      },
      subtitle_dark: {
        attr: 'ativo_proximo_vencimento',
        name: '',
      },
    },
    {
      title: 'IPS',
      color: 'primary',
      go_to: 'carteira.ips',
      checked: {
        attr: 'revisao_ips',
        name: '', // Nome do profissional
      },
      subtitle_light: {
        attr: '',
        name: 'Próx. revisão',
      },
      subtitle_dark: {
        attr: 'revisao_ips',
        name: '',
      },
    },
    {
      title: 'Simulação',
      color: 'primary',
      // can_show: 'portfolio_review',
      go_to: 'simulador',
      checked: {
        attr: 'revisao_simulacao',
        name: '', // Nome do profissional
      },
      subtitle_light: {
        attr: '',
        name: 'Próx. revisão',
      },
      subtitle_dark: {
        attr: 'revisao_simulacao',
        name: '',
      },
    },
    {
      title: 'Proposta',
      color: 'primary',
      disabled: true,
      checked: {
        attr: '',
        name: '',
      },
      subtitle_light: '',
      subtitle_dark: '',
    },
    {
      title: 'Consolidação',
      color: 'primary',
      disabled: true,
      checked: {
        attr: '',
        name: '',
      },
      subtitle_light: '',
      subtitle_dark: '',
    },
    {
      title: 'Envio de relatório (Rentabilidade)',
      color: 'primary',
      disabled: true,
      checked: {
        attr: '',
        name: '',
      },
      subtitle_light: 'Próx. envio relatório',
      subtitle_dark: '', // 30 dias
    },
  ],
  dados: {
    data_coleta: '',
    id_cliente: '',
    loading: false,
    value: {
      assets_due_date: {},
      client_data: {},
      portfolio_review_data: {},
      subscriptions: {},
      ips_data: {},
      financial_data: {},
      revenue_data: {},
    },
  },
  estrutura: {
    data_coleta: '',
    id_cliente: '',
    loading: false,
    value: {
      convite_app: '', // ok
      envio_convite: '',
      acesso_realizado: '', // ok
      data_registro: '', // ok
      servico: '', // ok
      servico_nome: '', // ok
      servico_dias_atras: '', // ok
      ativo_proximo_vencimento: '', // ok
      revisao_ips: '', // ok
      revisao_simulacao: '', // ok
      proposta: '',
      consolidacao: '',
      relatorio: '',
    },
  },
}
